<template>
    <div class="flex flex-col ev-table-wrap border">
        <ev-form
            v-for="(row, idx) in resolvedValue"
            :key="idx"
            class="w-full"
            :model-value="row" @update:model-value="(val)=>{updateRow(val, idx)}" :no-label="idx !== 0" label-top gridable >
            <slot></slot>
        </ev-form>
    </div>
</template>

<script>
    import EvForm from "./EvForm";
    export default {
        name: "EvTable",
        components: {EvForm},
        emits: ['input', 'update:modelValue', 'update:value'],
        props: {
            value: { default: undefined },
            modelValue: { default: undefined },
            errors: {
                default() {
                    return []
                }
            },
            prefix:null,
            hook: null,
            horizontal: {type: Boolean, default: false},
            labelTop: {type: Boolean, default: false}
        },
        computed: {
            resolvedValue() {
                const value = typeof this.modelValue !== 'undefined' ? this.modelValue : this.value;
                return Array.isArray(value) ? value : [];
            },
            getHeaders() {
                return [];
            },
            getItems() {
                return this.resolvedValue;
            }
        },
        methods:{
            alignLabels(){

            },
            setFieldValue(field, value){

            },
            getFieldValue(field){

            },
            getErrors(field){

            },
            clearError(field){

            },
            isLabelTop(){

            },
            updateRow(row, idx) {
                const values = [...this.resolvedValue];
                values[idx] = row;
                this.$emit('update:modelValue', values);
                this.$emit('update:value', values);
                this.$emit('input', values);
            }
        },
        mounted() {

        }
    }
</script>

<style lang="scss">

    .ev-table-wrap > form > div > div > .form-field-label{
        border-bottom: 1px solid;
    }
    .ev-table-wrap > form > div {
        box-sizing: border-box;
        border-right: 1px solid;
        border-bottom: 1px solid;
        padding:1px;
    }
    .ev-table-wrap > form:first-child{
        border-top: 1px solid;
        border-bottom: none;
    }
    .ev-table-wrap > form{
        border-left: 1px solid;
    }

</style>
